import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { CampaignRelanceJournalScreen } from '@/routes/admin/campaigns/campaign-relance-journal-screen';

// =============================================================================
// campaign-relance-journal-route.tsx — Adaptateur routeur du « Journal des relances » (R15-COM-05).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId/reminders-journal ») — ressource
// d'URL, cohérent avec le contrat API (campaignId server-set, invariant n°1). Le client relance-journal vient
// du contexte global (DÉFAUT = HTTP réel) : aucun provider local nécessaire. Le composant de présentation
// reste testable hors routeur.

const routeApi = getRouteApi(
  '/admin/campaigns/$campaignId/reminders-journal',
);

export function CampaignRelanceJournalRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();

  return <CampaignRelanceJournalScreen campaignId={campaignId} />;
}
